import useCurrentTenant from 'hooks/useCurrentTenant/useCurrentTenant';
import useEnqueueSnackbar from 'hooks/useEnqueueSnackbar';
import useTenantName from 'hooks/useTenantName/useTenantName';
import useTenantRegistrationInfo from 'hooks/useTenantRegistrationInfo/useTenantRegistrationInfo';
import React from 'react';
import { useSearchParams } from 'react-router';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import SyncingUsers from 'ui/templates/ConnectEntraID/SyncingUsers';
import WaitingForPermissions from 'ui/templates/ConnectEntraID/WaitingForPermissions';

const SyncingUsersAndFinishingPage: React.FC<React.PropsWithChildren> = () => {
  const [searchParams] = useSearchParams();
  const azureTenantId = searchParams.get('tenant');

  const enqueueSnackbar = useEnqueueSnackbar();
  const handleFetchError = (errorMessage: string) => enqueueSnackbar(errorMessage, { snackbartype: 'error' });
  const { registerAzureTenant, registerAzureTenantLoading } = useTenantRegistrationInfo({
    handleFetchError
  });
  const { tenantName, loading: tenantNameLoading } = useTenantName({
    handleFetchError,
    azureTenantId
  });

  const { currentTenant } = useCurrentTenant({ handleFetchError });

  const handleStartButtonOnClick = async () => {
    if (!registerAzureTenantLoading && azureTenantId) {
      try {
        await registerAzureTenant({ azureTenantId });
        // Registering does not return an updated tenant so the expected result is manually created.
        setCurrentTenantAction({
          ...currentTenant!,
          onboardingStep: 'TenantReadyEntra'
        });
      } catch {
        // useTenantRegistrationInfo's onError already shows the error message.
      }
    }
  };

  const waitinForPermissions = tenantNameLoading || tenantName === undefined;
  return waitinForPermissions ? (
    <WaitingForPermissions />
  ) : (
    <SyncingUsers organizationName={tenantName} onStartButtonClick={handleStartButtonOnClick} />
  );
};

export default SyncingUsersAndFinishingPage;
